import React from 'react'
import parse from 'html-react-parser'
import { RightArrow } from './icons'
import Link from '../utils/link'

const ServicesIntro = ({ services, content, button }) => {
  return (
    <section className='services-intro'>
      <div className='services-intro__inner'>
        <hr />
        <div className='services-intro__services'>
          <ul>
            { services?.map((service, i) => (
              <li key={i}>
                <h4>{service.title}</h4>
              </li>
            ))}
          </ul>
        </div>
        <div className='services-intro__content'>
          { content && <div>{parse(content)}</div> }
          { button?.url && button?.title && 
            <Link to={button.url} className='services-intro__button'>
              <span>{button.title}</span>
              <RightArrow />
            </Link>
          }
        </div>
      </div>
    </section>
  )
}

export default ServicesIntro